import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "perfil-page" }
const _hoisted_2 = { class: "profile-card" }
const _hoisted_3 = {
  key: 0,
  class: "inline-error profile-banner"
}
const _hoisted_4 = {
  key: 1,
  class: "profile-muted"
}
const _hoisted_5 = {
  key: 2,
  class: "inline-error profile-banner"
}
const _hoisted_6 = { class: "photo-row" }
const _hoisted_7 = {
  key: 0,
  class: "photo-avatar photo-avatar-image"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "photo-avatar"
}
const _hoisted_10 = { class: "photo-meta" }
const _hoisted_11 = { class: "photo-actions" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "form-grid" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = { class: "form-group full-width" }
const _hoisted_30 = { class: "actions" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = { class: "profile-card password-card" }
const _hoisted_33 = { class: "password-grid" }
const _hoisted_34 = { class: "form-group full-width" }
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = {
  key: 0,
  class: "inline-error"
}
const _hoisted_38 = { class: "actions password-actions" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = { class: "modal-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[40] || (_cache[40] = _createElementVNode("div", { class: "card-head" }, [
        _createElementVNode("h2", null, "Perfil"),
        _createElementVNode("p", null, "Atualize foto e informações gerais da sua conta.")
      ], -1)),
      _createElementVNode("form", {
        class: "profile-form",
        onSubmit: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => ($setup.saveProfile && $setup.saveProfile(...args)), ["prevent"]))
      }, [
        ($setup.loadError)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString($setup.loadError), 1))
          : _createCommentVNode("", true),
        ($setup.loadingProfile)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Carregando dados do perfil…"))
          : _createCommentVNode("", true),
        ($setup.profileSaveError)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString($setup.profileSaveError), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          ($setup.displayPhotoSrc)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("img", {
                  src: $setup.displayPhotoSrc,
                  alt: "Avatar do perfil"
                }, null, 8, _hoisted_8)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString($setup.initials), 1)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                type: "button",
                class: "photo-btn",
                disabled: $setup.loadingProfile || $setup.uploadingAvatar,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.triggerPhotoUpload && $setup.triggerPhotoUpload(...args)))
              }, _toDisplayString($setup.uploadingAvatar ? 'Enviando…' : 'Trocar foto'), 9, _hoisted_12),
              ($setup.displayPhotoSrc)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "photo-btn photo-btn-danger",
                    disabled: $setup.loadingProfile || $setup.uploadingAvatar || $setup.removingAvatar,
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.removePhoto && $setup.removePhoto(...args)))
                  }, _toDisplayString($setup.removingAvatar ? 'Removendo…' : 'Remover foto'), 9, _hoisted_13))
                : _createCommentVNode("", true)
            ]),
            _cache[25] || (_cache[25] = _createElementVNode("p", null, "JPEG, PNG ou WebP até 5MB", -1)),
            _createElementVNode("input", {
              ref: "photoInput",
              type: "file",
              accept: "image/png,image/jpeg,image/webp",
              class: "hidden-input",
              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.handlePhotoChange && $setup.handlePhotoChange(...args)))
            }, null, 544)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _cache[26] || (_cache[26] = _createElementVNode("label", { for: "displayName" }, "Nome", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "displayName",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.displayName) = $event)),
              type: "text",
              placeholder: "Seu nome completo"
            }, null, 512), [
              [_vModelText, $setup.form.displayName]
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[27] || (_cache[27] = _createElementVNode("label", { for: "email" }, "Email", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "email",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.email) = $event)),
              type: "email",
              placeholder: "joao@example.com",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.form.email]
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _cache[28] || (_cache[28] = _createElementVNode("label", { for: "companyName" }, "Nome da empresa", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "companyName",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.companyName) = $event)),
              type: "text",
              placeholder: "Nome da empresa"
            }, null, 512), [
              [_vModelText, $setup.form.companyName]
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _cache[29] || (_cache[29] = _createElementVNode("label", { for: "accountId" }, "ID da conta", -1)),
            _createElementVNode("input", {
              id: "accountId",
              value: $setup.currentUser?.userId || '',
              type: "text",
              disabled: ""
            }, null, 8, _hoisted_19)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _cache[30] || (_cache[30] = _createElementVNode("label", { for: "username" }, "Nome de usuário", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "username",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form.username) = $event)),
              type: "text",
              placeholder: "usuario.login"
            }, null, 512), [
              [_vModelText, $setup.form.username]
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _cache[31] || (_cache[31] = _createElementVNode("label", { for: "phone" }, "Telefone", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "phone",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.form.phone) = $event)),
              type: "text",
              placeholder: "(00) 00000-0000",
              maxlength: "15",
              onInput: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.formatPhoneInput && $setup.formatPhoneInput(...args)))
            }, null, 544), [
              [_vModelText, $setup.form.phone]
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _cache[32] || (_cache[32] = _createElementVNode("label", { for: "role" }, "Cargo", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "role",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.form.role) = $event)),
              type: "text",
              placeholder: "Ex: Advogado(a)"
            }, null, 512), [
              [_vModelText, $setup.form.role]
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _cache[33] || (_cache[33] = _createElementVNode("label", { for: "cpf" }, "CPF", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "cpf",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.form.cpf) = $event)),
              type: "text",
              maxlength: "14",
              placeholder: "000.000.000-00",
              inputmode: "numeric",
              autocomplete: "off",
              onInput: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => ($setup.formatCpfInput && $setup.formatCpfInput(...args)))
            }, null, 544), [
              [_vModelText, $setup.form.cpf]
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _cache[34] || (_cache[34] = _createElementVNode("label", { for: "bornDate" }, "Data de nascimento", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "bornDate",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.form.bornDate) = $event)),
              type: "date"
            }, null, 512), [
              [_vModelText, $setup.form.bornDate]
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _cache[35] || (_cache[35] = _createElementVNode("label", { for: "street" }, "Rua / endereço", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "street",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.form.street) = $event)),
              type: "text",
              placeholder: "Rua, número"
            }, null, 512), [
              [_vModelText, $setup.form.street]
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _cache[36] || (_cache[36] = _createElementVNode("label", { for: "neighborhood" }, "Bairro", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "neighborhood",
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.form.neighborhood) = $event)),
              type: "text"
            }, null, 512), [
              [_vModelText, $setup.form.neighborhood]
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _cache[37] || (_cache[37] = _createElementVNode("label", { for: "state" }, "Estado", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "state",
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.form.state) = $event)),
              type: "text",
              placeholder: "UF",
              maxlength: "2"
            }, null, 512), [
              [_vModelText, $setup.form.state]
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _cache[38] || (_cache[38] = _createElementVNode("label", { for: "country" }, "País", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "country",
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.form.country) = $event)),
              type: "text"
            }, null, 512), [
              [_vModelText, $setup.form.country]
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _cache[39] || (_cache[39] = _createElementVNode("label", { for: "notes" }, "Informações gerais", -1)),
            _withDirectives(_createElementVNode("textarea", {
              id: "notes",
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.form.notes) = $event)),
              rows: "4",
              placeholder: "Adicione observações sobre o perfil"
            }, null, 512), [
              [_vModelText, $setup.form.notes]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("button", {
            type: "submit",
            class: "primary-action",
            disabled: $setup.loadingProfile || $setup.savingProfile
          }, _toDisplayString($setup.savingProfile ? 'Salvando…' : 'Salvar informações'), 9, _hoisted_31)
        ])
      ], 32)
    ]),
    _createElementVNode("section", _hoisted_32, [
      _cache[44] || (_cache[44] = _createElementVNode("div", { class: "card-head" }, [
        _createElementVNode("h2", null, "Alterar Senha"),
        _createElementVNode("p", null, "Defina uma nova senha de acesso.")
      ], -1)),
      _createElementVNode("form", {
        class: "password-form",
        onSubmit: _cache[22] || (_cache[22] = _withModifiers(
//@ts-ignore
(...args) => ($setup.savePassword && $setup.savePassword(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _cache[41] || (_cache[41] = _createElementVNode("label", { for: "currentPassword" }, "Senha atual", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "currentPassword",
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.passwordForm.currentPassword) = $event)),
              type: "password",
              placeholder: "Digite sua senha atual"
            }, null, 512), [
              [_vModelText, $setup.passwordForm.currentPassword]
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _cache[42] || (_cache[42] = _createElementVNode("label", { for: "newPassword" }, "Nova senha", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "newPassword",
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.passwordForm.newPassword) = $event)),
              type: "password",
              placeholder: "Digite a nova senha"
            }, null, 512), [
              [_vModelText, $setup.passwordForm.newPassword]
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _cache[43] || (_cache[43] = _createElementVNode("label", { for: "confirmPassword" }, "Confirmar nova senha", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "confirmPassword",
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.passwordForm.confirmPassword) = $event)),
              type: "password",
              placeholder: "Repita a nova senha"
            }, null, 512), [
              [_vModelText, $setup.passwordForm.confirmPassword]
            ])
          ])
        ]),
        ($setup.passwordError)
          ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString($setup.passwordError), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("button", {
            type: "submit",
            class: "primary-action",
            disabled: $setup.loadingProfile || $setup.savingPassword
          }, _toDisplayString($setup.savingPassword ? 'Atualizando…' : 'Atualizar senha'), 9, _hoisted_39)
        ])
      ], 32)
    ]),
    ($setup.showSuccessModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal",
          onClick: _cache[24] || (_cache[24] = _withModifiers(($event: any) => ($setup.showSuccessModal = false), ["self"]))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["modal-content", { 'modal-content--avatar-upload-ok': $setup.modalVariant === 'avatarSuccess' }])
          }, [
            _createElementVNode("h2", null, _toDisplayString($setup.modalTitle), 1),
            _createElementVNode("p", {
              class: _normalizeClass(["modal-message", $setup.modalVariant])
            }, _toDisplayString($setup.modalMessage), 3),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[23] || (_cache[23] = ($event: any) => ($setup.showSuccessModal = false))
              }, " Fechar ")
            ])
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ]))
}